import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { GetBy } from '../_app/cuchillo/core/Element';
import Default from './Default';
import ProductScene from '../3D/ProductScene';
import BGImage from "../layout/BGImage";
import { Scroll } from '../_app/cuchillo/scroll/Scroll';


export default class Product extends Default {
  constructor() {
    super();
    ProductScene.init(this.container);
  }

  afterShow() {
    super.afterShow();
    ProductScene.animateIn();
  }

  loop() {
    super.loop();
    BGImage.scale = 1 + Scroll.progress;
    ProductScene.loop();
  }

  beforeHide() {
    ProductScene.hide();
    super.beforeHide();
  }

  afterHide() {
    BGImage.destroy();
    ProductScene.dispose();
    super.afterHide();
  }

  resize(__w, __h) {
    super.resize(__w, __h);
    ProductScene.resize();
  }
}

ControllerPage._addPage('page-product', Product);
